export default __webpack_public_path__ + "media/images/ui-bg_glass_100_e4f1fb_1x400-037d2fd1ee6fe1768020e5bf6c5768f1.png";